import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminComponent } from './admin/admin.component';
import { ApplicationComponent } from './application-dashboard/application.component';
import { MonthDashboardComponent } from './month-dashboard/month-dashboard.component';
import { NotesDetailComponent } from './notes-detail/notes-detail.component';
import { NoteEntryComponent } from './note-entry/note-entry.component';
import { PublishEmailComponent } from './email/publish-email.component';
import { AppEntryComponent } from './app-entry/app-entry.component';
import { DeployCalendarComponent } from './deploy-calendar/deploy-calendar.component';
import { SigninRedirectCallbackComponent } from './signin-redirect-callback/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './signout-redirect-callback/signout-redirect-callback.component';
import { LogOutComponent } from './logout/logout.component';
import { AdminGuard } from './guards/admin.guard';
import { CanDeactivateGuard } from './guards/canDeactivate.guard';


const routes: Routes = [
  { path: 'administration', component: AdminComponent, canActivate: [AdminGuard]  },
  { path: 'applicationEntry', component: AppEntryComponent, canActivate: [AdminGuard], canDeactivate: [CanDeactivateGuard]},
  { path: 'noteEntry', component: NoteEntryComponent, canActivate: [AdminGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'publishEmail/:noteID', component: PublishEmailComponent, canActivate: [AdminGuard] },
  { path: 'applications', component: ApplicationComponent },
  { path: 'deploymentCalendar', component: DeployCalendarComponent },
  { path: 'applications/:appName/:appID', component: MonthDashboardComponent },
  { path: 'applications/:appName/:appID/:month', component: NotesDetailComponent },
  { path: 'signin-oidc', component: SigninRedirectCallbackComponent },
  { path: 'signout-callback', component: SignoutRedirectCallbackComponent },
  { path: 'logout', component: LogOutComponent },
  { path: '', redirectTo: 'applications', pathMatch: 'full' },
  { path: '**', redirectTo: 'applications', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
